import BlProgressBarAv from './BlProgressBarAv.vue'

BlProgressBarAv.install = function(Vue) {
  Vue.component(BlProgressBarAv.name, BlProgressBarAv)
}

export default BlProgressBarAv
